import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginCoordinationService {
    private termsAcceptedSubject = new Subject<boolean>();
    termsAccepted$ = this.termsAcceptedSubject.asObservable();

    notifyTermsAccepted (value: boolean) {
        this.termsAcceptedSubject.next(value);
    }
}